import React from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import theme from './components/theme';
import AppRouter from './routes/AppRouter';
import './fonts.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div className="App">
        <AppRouter />
      </div>
    </ThemeProvider>
  );
}

export default App;
